// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview14BindJs from "./DragPreview14.bind.js";

var make = DragPreview14BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
